/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Section
 */
export interface Section {
    /**
     * 
     * @type {string}
     * @memberof Section
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Section
     */
    parent_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Section
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof Section
     */
    order_index?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Section
     */
    is_active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Section
     */
    date?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Section
     */
    roles?: Array<SectionRolesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Section
     */
    permissions?: Array<SectionPermissionsEnum>;
}


/**
 * @export
 */
export const SectionRolesEnum = {
    Physician: 'physician',
    Patient: 'patient',
    Admin: 'admin',
    Phlebotomist: 'phlebotomist'
} as const;
export type SectionRolesEnum = typeof SectionRolesEnum[keyof typeof SectionRolesEnum];

/**
 * @export
 */
export const SectionPermissionsEnum = {
    SuperAdmin: 'super_admin',
    Corporate: 'corporate',
    ShiftManager: 'shift_manager',
    Statistics: 'statistics'
} as const;
export type SectionPermissionsEnum = typeof SectionPermissionsEnum[keyof typeof SectionPermissionsEnum];


/**
 * Check if a given object implements the Section interface.
 */
export function instanceOfSection(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function SectionFromJSON(json: any): Section {
    return SectionFromJSONTyped(json, false);
}

export function SectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Section {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'parent_id': !exists(json, 'parent_id') ? undefined : json['parent_id'],
        'title': json['title'],
        'order_index': !exists(json, 'order_index') ? undefined : json['order_index'],
        'is_active': !exists(json, 'is_active') ? undefined : json['is_active'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'roles': !exists(json, 'roles') ? undefined : json['roles'],
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
    };
}

export function SectionToJSON(value?: Section | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'parent_id': value.parent_id,
        'title': value.title,
        'order_index': value.order_index,
        'is_active': value.is_active,
        'date': value.date,
        'roles': value.roles,
        'permissions': value.permissions,
    };
}

